import { Component, OnInit, Input } from '@angular/core';
import * as _ from 'lodash';
import * as $ from 'jquery'
@Component({
  selector: 'app-top-usage-bar',
  templateUrl: './top-usage-bar.component.html',
  styleUrls: ['./top-usage-bar.component.scss']
})
export class TopUsageBarComponent implements OnInit {
  @Input() consumption: any;
  @Input() uptime: any;
  top = 0
  devices = [];
  colors = ['#F05452', '#EE306D', '#705256'];
  constructor() { }

  ngOnInit(): void {

  }
  ngOnChanges() {
    
    this.devices = [];
    // this.consumption = _.sortBy(this.consumption, "consumption").reverse().slice(0,3)
    this.consumption = _.filter(this.consumption, function (o) { return o['device_name'] !== "Others"; })
    this.consumption = _.sortBy(this.consumption, "consumption").reverse().slice(0, 3)
    this.top = this.consumption[0]["consumption"]
    if (this.consumption) {
      this.consumption.forEach((item, index) => {
        item.color = this.colors[index]

        this.devices.push(item)

      })
    }
    
  }

}
